var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"rRLX9bTEymm9E4Ai8zpne"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["gsu-web@getsetup-inc"]={id:"rRLX9bTEymm9E4Ai8zpne"};
      